import * as React from 'react';
import { EventIndexView } from '../../../types/events';
import './eventCard.module.scss';
import moment from 'moment-timezone';
import { LocationBadge } from '../../atoms/locations/LocationLabel';

type Props = {
    event: EventIndexView;
    onClick: () => any;
};

export class EventCard extends React.Component<Props> {
    render() {
        const { event, onClick } = this.props;
        const { starts_at, ends_at } = event;
        const startsAt = moment(starts_at);
        const endsAt = moment(ends_at);
        const { coaches } = event;
        const coach = coaches.length > 0 && coaches[0];
        return (
            <div className="event-card" styleName="card" onClick={onClick} data-event-id={event.id}>
                <div styleName="thumbnail-wrapper">
                    <img styleName="thumbnail" src={event.thumbnail_photo_url['original']} />
                </div>
                <div styleName="main">
                    <div styleName="header">
                        <div styleName="datetime">
                            <div styleName="date">
                                <span styleName="date-no">{startsAt.format('M')}</span>月
                                <span styleName="date-no">{startsAt.format('D')}</span>日
                            </div>
                            <div styleName="time-range">
                                {startsAt.format('HH:mm')} - {endsAt.format('HH:mm')}
                            </div>
                        </div>
                        <LocationBadge location={event.location} />
                    </div>
                    <div styleName="title">{event.title}</div>
                    {coach && (
                        <div styleName="coaches">
                            <img src={coach.profile_photo_url} styleName="coach-profile" />
                            <div>
                                <div styleName="coach-name">
                                    {coach.name}
                                    {coaches.length > 1 && <span styleName="extra">他{coaches.length - 1}名</span>}
                                </div>
                                <div styleName="coach-title">{coach.title}</div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
